import { useTranslation } from "react-i18next";
import { TranslatedText } from "../../../Types/ApiTypes";
import DynamicTextArea from "../../DynamicTextArea";
import { getTranslation } from "../../../Utils/Converters";


interface MonsterModalListComponentProps {
    language: string,
    text: TranslatedText,
    updateText: (text: TranslatedText) => void,
    list: {title: TranslatedText, description: TranslatedText}[],
    updateList: (list: {title: TranslatedText, description: TranslatedText}[]) => void
}

const MonsterModalListComponent = (props: MonsterModalListComponentProps) => {
    const { t } = useTranslation();
    
    return (
        <div className="d-flex col-12 p-2 flex-column">
            <div className="d-flex col-12">
                <span className="col-2 pe-2">{t("monstermodal-text")}</span>
                <span className="col-9">
                    <span className="input-group">
                        <input 
                            value={getTranslation(props.text, props.language)}
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                                props.text[props.language] = e.target.value;
                                props.updateText({...props.text})
                            }}
                        ></input>
                    </span>
                </span>
                <span className="col-1 text-end">
                    <button className="btn btn-outline-primary text-center"
                        style={{width: "42px", height: "42px"}}
                        onClick={(e)=>{
                            e.preventDefault();
                            props.list.push({title: {en: "", it: ""}, description: {en: "", it: ""}})
                            props.updateList(props.list)
                        }}
                    >
                        <i className="bi bi-plus"></i>
                    </button>
                </span>
            </div>
            {props.list.map((element, index) =>{
                return(
                    <div className="col-12 d-flex flex-wrap pt-2" key={index}>
                        <span className="col-2 pe-2">{t("monstermodal-title")}</span>
                        <span className="col-9">
                            <span className="input-group">
                                <input 
                                    value={getTranslation(element.title, props.language)}
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => {
                                        element.title[props.language] = e.target.value;
                                        props.updateList(props.list)
                                    }}
                                ></input>
                            </span>
                        </span>
                        <span className="col-1 text-end">
                            <button className="btn btn-outline-danger text-center"
                                style={{width: "42px"}}
                                onClick={(e)=>{
                                    e.preventDefault();
                                    props.list.splice(index, 1);
                                    props.updateList(props.list)
                                }}
                            >
                                <i className="bi bi-trash-fill"></i>
                            </button>
                        </span>
                        <span className="col-2 pe-2">{t("monstermodal-description")}</span>
                        <span className="col-9">
                            <DynamicTextArea
                                updateText={(text: string)=>{
                                    element.description[props.language] = text;
                                    props.updateList(props.list)
                                }}      
                                areaText={getTranslation(element.description, props.language)}
                                placeholder={""}
                            />
                        </span>
                    </div>
                )
            })}
        </div>
    )
}

export default MonsterModalListComponent;